import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { GeoJSONObject } from '@/types/geospatial'

export interface Region {
  region_id: number
  project_id: number
  geojson?: GeoJSONObject
  col_name?: string
  region_name: string
  removed_features: string[]
}

export async function createRegions(payload: Region[]) {
  await companiesApi.post(apiRoutes.createRegions, payload)
}
